<template>
  <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
    <div class="text-[#414141] font-sans">
      <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">Overview</h3>
      
      <p class="text-[14px] leading-[22px] mb-[0.5rem]">Core Annual Programs should have measurable goals supported by clear, actionable data. To effectively demonstrate and evaluate your program’s impact, it’s essential to identify not only the long-term outcomes you aim to achieve but also the short- and mid-term outputs—concrete actions and milestones—that drive progress toward those outcomes. Equally important is developing a transparent and compelling approach for reporting these results to donors and stakeholders, reinforcing accountability and building trust in your organization’s work. </p>
    </div>
  </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation'; // Import the validation composable

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 